import React from 'react';
import swal from 'sweetalert';
import { Loader2, Plus, Trash2 } from 'lucide-react';
import i18n from '../../../../../i18n';
import { auctionApprove } from '../services/auctionApprovalServices';
import FileInputNew from '../../../../helpers/fileInputNew';
import { CustomModal } from '../../../../common/CustomModal';

export class AuctionApproveModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      is_loading: false,
      input: {
        account_number : '3140029348500' , 
        bank_name : 'ESTIDAMAH SMART SOLUTIONS LLC' , 
        client_name : 'ROP'
      },
      errors: {},
      fileInputs: [],
      file_receipt: null,
      split_vat_enabled: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      input: { ...prevState.input, [name]: value },
    }));
  };

  onFileChange = (event) => {
    if (event.target.name === 'file_receipt') {
      this.setState({ file_receipt: event.target.files[0] });
    }
    if (event.target.name === 'invoice') {
      this.setState({ invoice: event.target.files[0] });
    }
  };

  onFileChangeNew = (e, index) => {
    const updatedInputs = [...this.state.fileInputs];
    updatedInputs[index].file = e.target.files[0];
    this.setState({ fileInputs: updatedInputs });
  };

  addNewFileInput = () => {
    this.setState((prevState) => ({
      fileInputs: [...prevState.fileInputs, { id: prevState.fileInputs.length + 1, file: null }],
    }));
  };

  removeFile = (index) => {
    this.setState((prevState) => ({
      fileInputs: prevState.fileInputs.filter((_, i) => i !== index),
    }));
  };

  validateOfflineForm = () => {
    const { isClientEnrollment, user } = this.props;
    const { input, file_receipt, invoice } = this.state;
    const isClient = user.role === 'C';
    // For client enrollment, only validate payment_date and file_receipt
    if (isClientEnrollment) {
      if (!input.payment_date) return false;
      if (!isClient && !file_receipt) return false;
      return true;
    }

    let requiredFields = ['client_name', 'bank_name', 'account_number'];

    if (!isClient) {
      requiredFields.push('payment_date');
    }
    for (const field of requiredFields) {
      if (!input[field]) {
        return false;
      }
    }
    if (!isClient && !file_receipt) return false;

    return Boolean(invoice);
  };

  async handleSubmit(event) {
    event.preventDefault();
    const { input, fileInputs } = this.state;
    const { selectedIds, groupId, isClientEnrollment } = this.props;
    // const isClient = user?.role === 'C';

    const isValidOffline = this.validateOfflineForm();

    if (!isValidOffline) {
      swal(i18n.t('failed'), i18n.t('all_mandatory'), 'error');
      return;
    }

    try {
      this.setState({ is_loading: true });
      const formData = new FormData();

      // Common fields
      selectedIds.forEach((id, index) => {
        formData.append(`selected_ids[${index}]`, id);
      });
      formData.append('is_client_enrollment', isClientEnrollment ? 1 : 0);
      formData.append('group_id', groupId);
      formData.append('remarks', input.remarks || '');

      if (input.payment_date) {
        formData.append('payment_date', input.payment_date);
      }

      // Only add these fields if NOT client enrollment
      if (!isClientEnrollment) {
        formData.append('client_name', input.client_name);
        formData.append('bank_name', input.bank_name);
        formData.append('account_number', input.account_number);
        formData.append('vat_account_status', this.state.split_vat_enabled ? 1 : 0);
        formData.append('vat_account_number', input.vat_account_number);
      }

      if (this.state.file_receipt) {
        formData.append('attachment', this.state.file_receipt, this.state.file_receipt.name);
      }
      if (!isClientEnrollment && this.state.invoice) {
        formData.append('invoice', this.state.invoice, this.state.invoice.name);
      }

      if (fileInputs.length > 0) {
        fileInputs.forEach((input, index) => {
          if (input.file) {
            formData.append(`additional_attachments${index}`, input.file, input.file.name);
          }
        });
      }

      const response = await auctionApprove(formData);
      if (response && response.success) {
        swal(i18n.t('success'), i18n.t('auction_approved'), 'success');
        this.setState({ is_loading: false });
        if (this.props.onSuccess) {
          this.props.onSuccess(); // trigger parent refresh
        } else {
          this.props.onClose();
        }
      } else {
        swal(i18n.t('failed'), response.message, 'error');
        this.setState({ is_loading: false });
      }
    } catch (err) {
      console.log(err);
      this.setState({ is_loading: false });
    }
  }

  renderFileUpload = () => {
    const { fileInputs } = this.state;
    const { isClientEnrollment, user } = this.props;

    return (
      <div className="wallet-file-section">
        {user.role !== 'C' && (
          <div className="mb-3">
            <label className="wallet-form-label">{i18n.t('attachment')}</label>
            <div className="wallet-file-input-wrapper">
              <FileInputNew
                wrapperClass="wallet-file-input"
                placeholder={i18n.t('choose_file')}
                id="file_receipt"
                name="file_receipt"
                onChange={this.onFileChange}
                className="form-control"
                accept=".jpg,.jpeg,.png,.pdf"
              />
            </div>
          </div>
        )}
        {/* image 2  */}
        {!isClientEnrollment && (
          <div className="mb-3">
            <label className="wallet-form-label">{i18n.t('clinet_invoice')}</label>
            <div className="wallet-file-input-wrapper">
              <FileInputNew
                wrapperClass="wallet-file-input"
                placeholder={i18n.t('choose_file')}
                id="invoice"
                name="invoice"
                onChange={this.onFileChange}
                className="form-control"
                accept=".jpg,.jpeg,.png,.pdf"
              />
            </div>
          </div>
        )}
        {/* Additional files - only for offline tab */}

        <div className="wallet-additional-files">
          <label className="wallet-form-label">{i18n.t('additional_doc')}</label>
          {fileInputs.map((input, index) => (
            <div key={input.id} className="wallet-file-row mb-2">
              <div className="wallet-file-input-container">
                <FileInputNew
                  wrapperClass="wallet-file-input"
                  className="form-control"
                  placeholder={i18n.t('choose_file')}
                  name="file_receipt_addl"
                  id={`file_receipt_addl_${index}`}
                  onChange={(e) => this.onFileChangeNew(e, index)}
                />
                <button
                  type="button"
                  className="wallet-remove-file-btn"
                  onClick={() => this.removeFile(index)}
                  title="Remove file"
                >
                  <Trash2 size={20} />
                </button>
              </div>
            </div>
          ))}
          <button className="wallet-add-file-btn" onClick={this.addNewFileInput} type="button">
            {/* <i className="fa fa-plus" /> */}
            <Plus size={20} />
            <span>{i18n.t('add_new')}</span>
          </button>
        </div>
      </div>
    );
  };
  renderOfflineForm = () => {
    const { input, errors } = this.state;
    const { isClientEnrollment, user } = this.props;

    return (
      <div className="wallet-form-content">
        <div className="row">
          {!isClientEnrollment && (
            <>
              <div className="col-md-6 mb-3">
                <label className="wallet-form-label">
                  {user.role === 'C' ? i18n.t('beneficiary_name') : i18n.t('client_name')}
                </label>
                <input
                  type="text"
                  name="client_name"
                  value={input.client_name || ''}
                  onChange={this.handleChange}
                  className="wallet-form-input"
                  placeholder={
                    user.role === 'C'
                      ? i18n.t('please_enter_beneficiary_name')
                      : i18n.t('please_enter_client_name')
                  }
                />
                <div className="wallet-error">{errors.client_name}</div>
              </div>

              <div className="col-md-6 mb-3">
                <label className="wallet-form-label">{i18n.t('bank_name')}</label>
                <input
                  type="text"
                  name="bank_name"
                  value={input.bank_name || ''}
                  onChange={this.handleChange}
                  className="wallet-form-input"
                  placeholder={i18n.t('bank_name')}
                />
                <div className="wallet-error">{errors.bank_name}</div>
              </div>

              <div className="col-md-6 mb-3">
                <label className="wallet-form-label">{i18n.t('account_number')}</label>
                <input
                  type="text"
                  name="account_number"
                  value={input.account_number || ''}
                  onChange={this.handleChange}
                  className="wallet-form-input"
                  placeholder={i18n.t('enter_account_number')}
                />
                <div className="wallet-error">{errors.account_number}</div>
              </div>

              

              {this.state.split_vat_enabled && (
                <div className="col-md-6 mb-3">
                  <label className="wallet-form-label">{i18n.t('vat_account_number')}</label>
                  <input
                    type="text"
                    name="vat_account_number"
                    value={input.vat_account_number || ''}
                    onChange={this.handleChange}
                    className="wallet-form-input"
                    placeholder={i18n.t('enter_vat_account_number')}
                  />
                  <div className="wallet-error">{errors.vat_account_number}</div>
                </div>
              )}
            </>
          )}
          {user.role !== 'C' && (
            <div className="col-md-6 mb-3">
              <label className="wallet-form-label">{i18n.t('final_due_date')}</label>
              <input
                type="date"
                name="payment_date"
                value={input.payment_date || ''}
                onChange={this.handleChange}
                className="wallet-form-input"
                placeholder={i18n.t('payment_date')}
              />
              <div className="wallet-error">{errors.payment_date}</div>
            </div>
          )}
        </div>
      </div>
    );
  };
  render() {
    const { show, onClose, isClientEnrollment } = this.props;
    const { is_loading, input } = this.state;
    return (
      <CustomModal
        isOpen={show}
        header={
          isClientEnrollment
            ? i18n.t('client_enrollment_auction_approval')
            : i18n.t('auction_approval')
        }
        onClose={onClose}
      >
        {/* Form Content */}
        <div className="wallet-form-container">
          <form className="wallet-form" autoComplete="off">
            {this.renderOfflineForm()}

            {/* File Upload Section */}
            {this.renderFileUpload()}

            {/* Remarks Section */}
            <div className="wallet-remarks-section">
              <label className="wallet-form-label">{i18n.t('remarks')}</label>
              <textarea
                name="remarks"
                value={input.remarks || ''}
                onChange={this.handleChange}
                rows={4}
                className="wallet-textarea"
                placeholder={i18n.t('enter_remarks')}
              />
            </div>

            {/* Action Buttons */}
            <div className="wallet-actions">
              <button type="button" className="modal-btn btn-cancel" onClick={onClose}>
                {i18n.t('cancel')}
              </button>
              <button
                type="button"
                className="modal-btn btn-confirm"
                onClick={this.handleSubmit}
                disabled={is_loading}
              >
                {is_loading ? (
                  <span
                    style={{
                      color: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px',
                    }}
                  >
                    <Loader2 className="animate-spin" size={16} /> {i18n.t('approve')}
                  </span>
                ) : (
                  i18n.t('approve')
                )}
              </button>
            </div>
          </form>
        </div>
      </CustomModal>
    );
  }
}
